// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

export const getCustomerForm = state => state.getPaidReducer.customerForm;
export const getCustomerFormStatus = state => state.getPaidReducer.customerFormStatus;
export const getDiscountCode = state => state.getPaidReducer.discountCode;
export const getDiscountCodeStatus = state => state.getPaidReducer.discountCodeStatus;
export const getActiveDiscountCode = state => state.getPaidReducer.activeDiscountCode;
